export default __webpack_public_path__ + "assets/078ac3f696f07174a4f41dfa0e54f5ca.png";